/* Built In Imports */
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
// Component
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Services */

/**
 * 
 * @param {Object} param0 
 * @returns 
 */
const Language = ({ sectionContent, region, lang }) => {
  //   consoleLog(sectionContent[0].body);
  return (
    <Box maxW={'1300px'} mx={{ base: '0', lg: 'auto', md: '15px' }}>
      <Flex
        flexDir={'column'}
        alignItems="center"
        py={'60px'}
        background="#f5f0e5"
      >
        <style>
          {`
          .title p{
                    font-family: 'FedraSansStd-book';
                    font-size: 36px;
                    color: #060606;
                    line-height: 2.17;
                  }
          .text p{
                    font-family: "FedraSansStd-book", sans-serif;
                    font-size: 36px;
                    color: #000000;
                    margin-top: 20px;
                  }
          @media only screen and (max-width: 767px) {
            .title p{
                    font-size: 24px;
                    line-height: 1.33;
                  }
         .text p{
                    font-size: 20px;
                    margin-top: 20px;
                  }
                  }
         
                  }
          `}
        </style>
        <Flex
          textAlign={'center'}
          alignItems="center"
          justifyContent="center"
          className="title" p="15px"
        >
          <StructuredTextParser
            str={render(sectionContent[0]?.body)}
            region={region}
            lang={lang}
          />
        </Flex>
        <Flex
          alignItems={'center'}
          textAlign="center"
          justifyContent={'center'}
          className="text"
          p="15px"
        >
          <StructuredTextParser
            str={render(sectionContent[1]?.body)}
            region={region}
            lang={lang}
          />
        </Flex>
      </Flex>
    </Box>
  );
};

export default Language;

